import { useSelector } from 'react-redux';
import { cn, selectSession } from '..';
import { isNullOrUndefined } from '@shared';
import { IoArrowBackCircleSharp } from 'react-icons/io5';
import { useAdvisorNavigation } from '../hooks/useAdvisorNavigation';

type BackToDashboardButtonProps = {
  className?: string;
};
export function BackToDashboardButton({
  className,
}: BackToDashboardButtonProps) {
  const session = useSelector(selectSession);
  const { navigateToClientsDashboard } = useAdvisorNavigation();

  if (isNullOrUndefined(session.advisor?.advisorId)) {
    return null;
  }

  return (
    <button
      className={cn(
        className,
        'mt-6 flex items-center gap-2 rounded-lg px-2 py-2 text-gray-800 hover:text-mediumPurple hover:underline',
      )}
      onClick={navigateToClientsDashboard}
    >
      <IoArrowBackCircleSharp className="h-6 w-6 text-gray-800" />
      <span className="text-base text-gray-800">Back to Dashboard</span>
    </button>
  );
}
